export const GLOBAL_REGISTRATION_LABELS = 'global.registration';
export const lblCreateAcntSuccessMsg = 'lbl_createAccount_succcessMsg';
export const lblcreateAcntPointRwd = 'lbl_createAccount_pointReward';
export const lblCreateAcntTitle = 'lbl_createAccount_title';
export const lblCreateAcntCreate = 'lbl_createAccount_createA';
export const lblCreateAcntPlaceRewards = 'lbl_createAccount_myPlaceRewards';
export const lblCreateAcntEarnPoints = 'lbl_createAccount_earnPoints';
export const lblCreateAcntSignedUp = 'lbl_createAccount_signedUp';
export const lblCreateAcntCreatedOnline = 'lbl_createAccount_onlineAccCreated';
export const lblcreateAcntResetPwd = 'lbl_createAccount_resetPassword';
export const lblCreateAcntBrandTcp = 'lbl_createAccount_brand_alt_tcp';
export const lblCreateAcntBrandGym = 'lbl_createAccount_brand_alt_gym';
export const lblCreateAcntTopSecTitle = 'lbl_createAccount_top_section_title';
export const lblCreateAcntPlccCheckboxText = 'lbl_createAccount_plcc_checkbox_Text';
export const lblCreateAcntAlready = 'lbl_createAccount_alreadyAccount';
export const lblCreateAcntRememberMe = 'lbl_createAccount_rememberMe';
export const lblCreateAcntRememberDevice = 'lbl_createAccount_rememberMeHelpText';
export const lblCreateAcntShow = 'lbl_createAccount_show';
export const lblCreateAcntHide = 'lbl_createAccount_hide';
export const lblCreateAcntTouchId = 'lbl_createAccount_useTouchId';
export const lblCreateAcntFaceId = 'lbl_createAccount_useFaceId';
export const lblCreateAccountError = 'lbl_createAccount_error';

export const GlobalRegistrationLabels = {
  global: {
    registration: {
      [lblCreateAcntSuccessMsg]:
        'Yay! Your account has been created. Log in every time you shop to earn points.',
      [lblcreateAcntPointRwd]: '',
      [lblCreateAcntTitle]: 'EARN POINTS, GET REWARDS',
      [lblCreateAcntCreate]: 'Create a ',
      [lblCreateAcntPlaceRewards]: 'My Place Rewards ',
      [lblCreateAcntEarnPoints]: ' account to earn points on every purchase!',
      [lblCreateAcntSignedUp]: 'Signed up in store?',
      [lblCreateAcntCreatedOnline]: 'An online account has been created with your email.',
      [lblcreateAcntResetPwd]: ' Reset your password.',
      [lblCreateAcntBrandTcp]: "The Children's Place",
      [lblCreateAcntBrandGym]: 'Gymboree',
      [lblCreateAcntTopSecTitle]: 'CREATE ACCOUNT',
      [lblCreateAcntPlccCheckboxText]:
        'Save My Place Rewards Credit Card ending in #number to my account for future purchases.',
      [lblCreateAcntAlready]: 'Already have an account? Log In.',
      [lblCreateAcntRememberMe]: 'Remember me',
      [lblCreateAcntRememberDevice]: '(Not recommended on shared devices.)',
      [lblCreateAcntShow]: 'Show',
      [lblCreateAcntHide]: 'Hide',
      [lblCreateAcntTouchId]: 'Enable login with Touch ID',
      [lblCreateAcntFaceId]: 'Enable sign in with Face ID',
      [lblCreateAccountError]: 'There is some error in creating Account. Please try again.',
      lbl_createAccount_error__ERR_INVALID_EMAIL: 'Please enter a valid email address',
      lbl_createAccount_error__ERR_INVALID_EMAIL_DOMAIN: 'Please enter a valid email address',
      lbl_create_account_confirmation: 'Create a password to create your account.',
      lbl_createAccount_clickhere: ' Click here',
      lbl_createAccount_confirmEmail: 'Confirm Email Address',
      lbl_createAccount_confirmPassword: 'Confirm Password',
      lbl_createAccount_error__ERR_ACCOUNT_EXISTS_IN_SESSION:
        'Please login to verify your recently created account #emailValue#. If you are unable to verify this account, you may create a new account by clearing your browsers cookies or by using a different browser or device.',
      lbl_createAccount_error__ERR_ACCOUNT_EXISTS_IN_SESSION_APP:
        'Please login to verify your recently created account #emailValue#. If you are unable to verify this account, you may create a new account by',
    },
  },
};
